// Mapeos entre el contacto que devuelve el backend y el estado del formulario
// de ContactDetailModal, más el formateo de errores de validación del backend.

export function toEmailObjects(contact) {
  if (!contact?.emails?.length) return [{ data: "", type: null }];
  return contact.emails.map((emailEntry) => ({
    id: emailEntry.id,
    data: emailEntry.data ?? "",
    type: emailEntry.type ?? null,
    active: emailEntry.active,
  }));
}

export function toPhoneObjects(contact) {
  if (!contact?.contacts?.length) return [{ data: "", type: null }];
  return contact.contacts.map((phoneEntry) => ({
    id: phoneEntry.id,
    data: phoneEntry.data ?? "",
    type: phoneEntry.type ?? null,
  }));
}

export function toCompanyValue(contact) {
  if (!contact?.company) return null;
  return { id: contact.company, name: contact.company_name ?? "" };
}

export function formatBackendErrors(errors) {
  if (!errors || typeof errors !== "object") return null;

  const messages = Object.values(errors).flatMap((value) =>
    Array.isArray(value) ? value : [String(value)],
  );

  return messages.length ? messages.join(" ") : null;
}
